import { Component } from '@angular/core';
import { ModalController, ViewController, Events, NavParams } from 'ionic-angular';
import { RepositoryMyRadiant, UserMyRadiant, HelperMyRadiant } from '../../providers';

/**
 * Generated class for the cmpFilterdepartment component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'myOrganization',
  templateUrl: 'cmp.html'
})
export class cmpMyOrganization {

  text: string;
  departmentActive : string = 'me';
  loading : any;
  data= {
    list:[],
    struktur_organisasi:[],
    title:""
  };
  count_expand = 0;
  level_parent = 1;
  parameter = {
    keyword:'',
    id : this.userApi.data.Employee_ID,
    user_code : this.userApi.data.NIK,
    nik: this.userApi.data.NIK,
    state:null
  };
  searching = this.navParams.get('fiturSearching') || false;
  constructor(
    public viewCtrl   : ViewController,
    public events     : Events,
    public navParams  : NavParams, 
    public repositoryMyRadiant : RepositoryMyRadiant,
    public userApi : UserMyRadiant,
    public helper : HelperMyRadiant, 
  ) {
    let lastClick = localStorage.getItem('presensi_department_selected');
    if (lastClick != undefined) {
      this.departmentActive = localStorage.getItem('presensi_department_selected');
    }
    let stateParams = this.navParams.get('isAddHoc');
    this.level_parent = this.navParams.get('level');

    this.events.subscribe('department:selected',(department) => {
      this.pilihDepartment({},department);
    });

    if (stateParams) {
      this.data.struktur_organisasi = this.navParams.get('karyawan')
    }else{
      this.navParams.get('karyawan').forEach(row => {
        if (row.flag == 'people') {
          this.data.list.push(row);
        }else{
          this.data.struktur_organisasi.push(row);
        }
      });    
    }
    this.data.title = this.navParams.get('title');  
    
  }

  tutup(){
    this.viewCtrl.dismiss(false); 
  }

  pilihKaryawan(evt,karyawan){
    if (karyawan=='me') {
      localStorage.setItem('presensi_department_selected',karyawan);
      this.departmentActive = karyawan;
      this.viewCtrl.dismiss(karyawan);  
    }else{
      localStorage.setItem('presensi_department_selected',karyawan.name);
      this.departmentActive = karyawan.name;
      this.viewCtrl.dismiss(karyawan);
    }
    
  }

  pilihDepartment(evt,department){
    if (department=='me') {
      localStorage.setItem('presensi_department_selected',department);
      this.departmentActive = department;
      this.viewCtrl.dismiss(department);  
    }else{
      localStorage.setItem('presensi_department_selected',department.TEXT);
      this.departmentActive = department.TEXT;
      console.log(department);
      this.viewCtrl.dismiss(department);
    }
    
  }

  onSearch(){
    this.loading = this.helper.showLoading("Loading Data..");
    this.repositoryMyRadiant.getBawahan(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        this.data.list = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });  
  }
  getDataTree(params,callback) {  
    params.active_tab = localStorage.getItem('tabActiveProfile');  
    let maskLoading = this.helper.showLoading('Memuat...');
    this.repositoryMyRadiant.childrenMyOrganization(params).subscribe((resp:any) => {
      if (callback) {
        callback(resp.data.list);
      }
      setTimeout(() => {
        maskLoading.dismiss();        
      }, 500);  
    });
    //get tree 
  }
  onExpand(node) {
    let me = this;    
    me.count_expand += 1;
    let index = this.findIndexTree(me.data.struktur_organisasi,node.level,node.NODE_ID,me.level_parent-1);    
    if (index !== -1) {        
      if (!("Children" in index))
      {
        this.getDataTree(node,function(result) {                                       
            result.forEach(function(row,i) {
              result[i].TEXT = row.TEXT;
              result[i].state = 'opened';
              result[i].checked = node.checked;
            });
            index.Children = result;
           
        });
      }
    } 
    // this.pencarian.setData("data_unit_orgnisasi",me.data_tree);
  }

  findIndexTree(data,level,node_id,index) {
    let me = this,
        dt = data;
        console.log(index,level);
      if (level != index) {
        let idnode = node_id.split(".", index+1).join().replace(/,/g, '.')+'.';
        // index = level -1 ;
      console.log(idnode);
      let idx = me.helper.findValueFromArrayObject(data,"NODE_ID",idnode);   
      console.log(idx);         	
      if (idx !== -1) {        
        dt = data[idx];                
        console.log("dt",dt);    
        if ("Children" in dt) {          
          console.log("have children");
          dt = me.findIndexTree(dt.Children,level,node_id,index+1);
        }
      }
    }        
    return dt;
  }

}



// WEBPACK FOOTER //
// ./src/components/myOrganization/cmp.ts